import React from 'react';
import { motion } from 'framer-motion';
import OfferCard from './OfferCard';
import { NESPRESSO_OFFERS } from '../config/offers';

interface OfferGridProps {
  selectedOfferId: string | null;
  onSelectOffer: (offerId: string) => void;
  onAcceptOffer: (offerId: string) => void;
}

const OfferGrid: React.FC<OfferGridProps> = ({
  selectedOfferId,
  onSelectOffer,
  onAcceptOffer,
}) => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.4 }}
      className="grid grid-cols-3 gap-6 max-w-5xl w-full"
    >
      {NESPRESSO_OFFERS.map((offer, index) => (
        <motion.div
          key={offer.id}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4, delay: index * 0.1 }}
        >
          <OfferCard
            offer={offer}
            isSelected={selectedOfferId === offer.id}
            onSelect={onSelectOffer}
            onAccept={onAcceptOffer}
          />
        </motion.div>
      ))}
    </motion.div>
  );
};

export default OfferGrid;
